import InputTextCustom from "../Components/Inputs/InputTextCustom";
import LoadBtn from "../Components/Inputs/LoadBtn";
import axios from "axios";
import { useState } from "react";
import { useFormik } from "formik";
import { contactSchema } from "../utils/validationSchema";
import { useDispatch, useSelector } from "react-redux";
import { Card, Stack } from "@mui/material";
import { showNotificationHandel } from "../Redux/sliceReducers/notificationsSlice";
import {
  catalogTabaqatApi,
  contactInfoArr,
  contactInitialVals,
} from "../utils/StaticVariables";
import useContentHook from "../hooks/useContentHook";
const Contact = () => {
  // get data from redux
  const dispatch = useDispatch();

  // get country phon numper from redux
  const { chosenCountryPhoneNum } = useSelector((state) => state.globalVars);
  const { getContentText } = useContentHook();

  const [isLoading, setIsLoading] = useState(false);
  //  use formik to handle forms
  const formik = useFormik({
    initialValues: contactInitialVals,
    validationSchema: contactSchema,
    // submit data
    onSubmit: (values) => {
      const apiReqVal = {
        ...values,
        phone_number: chosenCountryPhoneNum + values.phone_number,
      };
      setIsLoading(true);

      //  call api in contact us
      axios
        .post(catalogTabaqatApi + "/contact", apiReqVal)
        .then(() => {
          formik.resetForm();
          dispatch(
            showNotificationHandel({
              msg: getContentText("account_contactMsg"),
            })
          );
        })
        .catch(() => {
          //  show error massege
          dispatch(
            showNotificationHandel({
              msg: getContentText("account_errorMsg"),
              variant: "error",
            })
          );
        })
        .finally(() => {
          //  stop loading
          setIsLoading(false);
        });
    },
  });

  return (
    <Stack sx={{ minHeight: "85vh" }}>
      <Card component="form" sx={formStyle}>
        {/* render inputs  */}
        {contactInfoArr.map((el) => (
          <InputTextCustom
            key={el.name}
            formik={formik}
            {...el}
            label={getContentText(el.label)}
          />
        ))}
        {/* loading btn stop when result arrive */}
        <LoadBtn loading={isLoading} fun={formik.submitForm} />
      </Card>
    </Stack>
  );
};
export default Contact;

const formStyle = {
  p: { xs: 1.5, sm: 2, md: 4 },
  m: "auto",
  width: { xs: "100%", md: "75%" },
  maxWidth: "900px",
};
